const enum SUBMIT_TYPE {
  NEW = "NEW",
  EDIT = "EDIT"
}

export default SUBMIT_TYPE

export enum USER_ROLES {
  None = "None",
  SUPERVISOR = "Supervisor",
  CATEGORY_UPDATE = "CategoryUpdate",
  GLOBAL_FUND_COUNT = "GlobalFundCount",
  GLOBAL_FUND_COUNT_RESTRICTED = "GlobalFundCountRestricted",
  CTCI = "CTCI",
  MFUND_FTP = "MFUNDFTP",
  STANDARD = "Standard",
  FIRM_ADMIN = "FirmAdmin",
  VIEW_ONLY = "ViewOnly",
  VENDOR = "Vendor",
  PRICING_AGENT = "PricingAgent",
  VENDOR_NO_CUSIP = "VendorNoCUSIP",
  NAV_CUSIP = "NAVCUSIP",
  NAV_NO_CUSIP = "NAVNoCUSIP",
  DL_DIRECTORY_LEVEL_2 = "DlDirectoryLevel2",
  ROOT = "Root",
  DL_DIRECTORY_LEVEL_3 = "DlDirectoryLevel3",
  PRICE_NO_BILL = "PriceNoBill",
  ALL = "All"
}

export enum DOCUMENT_STATUS {
  PENDING = "Pending",
  ACTIVE = "Active",
  INACTIVE = "Inactive"
}

export enum SELECT_VALUES {
  YES = "yes",
  NO = "no"
}

export enum MODAL_ACCESS_TYPES {
  ADD = "Add",
  EDIT = "Edit",
  NEW = "New",
  VIEW = "View",
  RESTORE = "Restore",
  READD = "Readd",
  DELETE = "Delete"
}

export enum BASIC_STATUS {
  ACTIVE = "Active",
  INACTIVE = "Inactive"
}

export enum DocumentTypeEnum {
  Sai = "SAI",
  Month = "MONTH",
  Profil = "PROFIL",
  Pstat = "PSTAT",
  Psumm = "PSUMM",
  Pdrft = "PDRFT",
  Sharea = "SHAREA",
  Shares = "SHARES",
  Delete = "DELETE",
  Name = "NAME",
  Reorg = "REORG",
  Ppm = "PPM",
  Mkmat = "MKMAT",
  Dctrst = "DCTRST",
  Potna = "POTNA",
  Sumpd = "SUMPD",
  Other = "OTHER",
  Kiid = "KIID"
}

export enum ApplicationTypeEnum {
  NEWAPP = "NEWAPP",
  DELETE = "DELETE",
  RSTORE = "RSTORE",
  GCHNGE = "GCHNGE",
  UITREP = "UITREP",
  ADDLIKE = "ADDLIKE",
  REPLCE = "REPLCE"
}

export enum ApplicationTypeDescriptionEnum {
  NEWAPP = "New Application",
  DELETE = "Deletion",
  RSTORE = "Restore",
  GCHNGE = "Attribute Change",
  UITREP = "Replacement",
  REPLCE = "Replacement"
}

export enum InstrumentStatusEnum {
  APPROV = "APPROV",
  CLOSED = "CLOSED",
  DELETE = "DELETE",
  LIVE = "LIVE",
  PENDAP = "PENDAP",
  SAVED = "SAVED",
  WITHDR = "WITHDR",
  NS = "NS"
}

export enum InstrumentStatusDescriptionEnum {
  APPROV = "APPROVED",
  CLOSED = "CLOSED",
  DELETE = "DELETED",
  LIVE = "LIVE",
  PENDAP = "PENDING APPROVAL",
  SAVED = "SAVED",
  WITHDR = "WITHDRAW",
  NS = "NOT SAVED"
}

export enum DistributionTypeEnum {
  NOT_APPLICABLE = "NA",
  CASH = "CASH",
  REINVESTMENT = "REINVS",
  WRAP = "WRAP",
  REINVESTMENT_CASH = "RECASH",
  REINVESTMENT_WRAP = "REWRAP"
}

export enum TIMELINE_STATUS {
  CURRENT = "CURRENT",
  FUTURE = "FUTURE"
}

export enum FileExtensions {
  CSV = "csv",
  TEXT = "txt",
  JSON = "json"
}

export enum StatusApprovalEnum {
  Pending = "Pending",
  Active = "Active",
  Inactive = "Inactive"
}

export enum InstrumentDeletionReasonEnum {
  LIQUIDATED = "LQDTD" as any,
  MERGED = "MRGD" as any,
  ACQUIRED = "QRD" as any,
  TERMINATED_EXPIRED = "TRMNTD" as any,
  REMOVED_AT_ISSUERS_REQUEST = "RMVDSS" as any,
  REMOVED_BY_NASDAQ = "RMVDNS" as any,
  ISSUANCE_POSTPONED = "PSTPND" as any,
  ISSUANCE_CANCELLED = "CANCLD" as any,
  INSTRUMENT_CONVERSION = "ICNVER" as any,
  INSTRUMENT_REORGANIZATION = "REORG" as any,
  ISSUER_CALLED = "ISSCAL" as any,
  AUTO_CALLED = "ATOCAL" as any,
  MATURED = "MATURE" as any
}

export enum ServiceCallReportTypes {
  ADVANCED = "DLAdvance",
  NEXT_DAY = "DLNextDay",
  DOCUMENTS = "DocPost",
  DOCUMENTS_ASSIGNED = "DocumentsAssigned",
  INSTRUMENT_DIRECTORY = "InstrumentDirectory",
  PRODUCT = "ProductDirectory",
  PRODUCT_ASSET = "productassetcategory",
  PRODUCT_REGION = "productregionweights",
  PRODUCT_ALLOCATIONS = "productallocations",
  PRODUCT_MANAGEMENT = "productmanagements",
  PRODUCT_COUNTRY = "productcountryofsale",
  PRODUCT_HOLDINGS = "productholdings",
  EXPENSE = 'Expense'
}

export enum CustomFilterTypes {
  SELECT = "SELECT",
  DATE = "DATE",
}